module.exports = __webpack_public_path__ + "static/img/40013 (3).20bd824.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40013 (3).webp
// module id = BDIC
// module chunks = 14